/**
 * Created by fan on 1/17/17.
 */
angular.module('smartorg.r6.acts.universal', [
    // require('../app/universal-table/app/js/plumbing/app'),
    require('./universal-table2/universal-table.component')
]);
module.exports = 'smartorg.r6.acts.universal';
//# sourceMappingURL=app.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/app.js